
import 'antd/dist/antd.css'
/*svapr20 start
import Chat from '../core/Chat'
*/
import { message } from 'antd';
import {COSMOS_DEF_MAX_ALL_ADV_DAYS,COSMOS_DEF_SEARCH_ADV_DAYS,COSMOS_DEF_ROUND_ADV_DAYS_O,COSMOS_DEF_ROUND_ADV_DAYS_D} from '../../constants'
import SVRAiport from '../../views/SVRAirport';
import SVKAiport from '../../views/SVKAirport';
import SVKAirportDest from '../../views/SVKAirportDest';
import SVRSojournDest from '../../views/SVRSojournDest'

import FlyMciFormBusCom from '../../components/sojourns/FlyMciFormBusCom'
import React, { Component } from "react";
import { AutoComplete , Input, Card, DatePicker, Select} from 'antd'
import moment from 'moment'
import '../../css/SearchBar.css'

const { Option } = Select;
const { MonthPicker, RangePicker } = DatePicker;



const { Search } = Input;



const infoError = () => {
  message.info('Please enter all valid data');
};

class FlySearchBar extends Component{
    svsubmitparentmci(formValues){
        let me = this
        
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback**********parent')
      
      console.log(formValues)

      const svmcityOb = {my_data_svmci:formValues }
      const {filters} = this.state
      let filter = filters
      const {startDate, endDate, hotels, esqueryText,esqueryDestText,
        esqueryAdults, esqueryCabin,esqueryChilds,esqueryInfants,esqueryTripType} = filter
      let svcities = []
      let STARTDATE_ITN_TZAWARE_EST = "2025-11-25"
      let ENDDATE_ITN_TZAWARE_EST =  "2025-12-25"
      let org = 'JFK', dst = 'SFO'
     
      let fcities = (formValues.members && formValues.members.length > 0) ? formValues.members : []
      for(let i=0; i < fcities.length; i++ ){
          let fcity =fcities[i]
        let city_tp = {
            "id": "1",
            "originLocationCode": "JFK",
            "destinationLocationCode": "LAX",
            "departureDateTimeRange": {
                "date": "2024-12-03"
            }
        }

        city_tp["id"] = "" +fcity["tid"]
        city_tp["originLocationCode"] = fcity["my_orgqueryText"].toLocaleUpperCase()
        city_tp["destinationLocationCode"] =fcity["my_dstqueryText"].toLocaleUpperCase()
        city_tp["departureDateTimeRange"] = {
            "date": "2024-12-03"
        }
        city_tp["departureDateTimeRange"]["date"] = fcity["STARTDATE"]
        if(i === 1){
            STARTDATE_ITN_TZAWARE_EST = fcity["STARTDATE"]
            org = fcity["my_orgqueryText"].toLocaleUpperCase()
        }

        if(i === (fcities.length - 1) ){
            ENDDATE_ITN_TZAWARE_EST = fcity["STARTDATE"]
            dst = fcity["my_dstqueryText"].toLocaleUpperCase()
        }
        
        svcities.push(city_tp)

      }

      let sojPostPyRq = {
        "svcities":[
            {
                "id": "1",
                "originLocationCode": "JFK",
                "destinationLocationCode": "LAX",
                "departureDateTimeRange": {
                    "date": "2024-12-03"
                }
            },
            {
                "id": "2",
                "originLocationCode": "LAX",
                "destinationLocationCode": "SFO",
                "departureDateTimeRange": {
                    "date": "2024-12-07"
                }
            },
            {
                "id": "3",
                "originLocationCode": "SFO",
                "destinationLocationCode": "JFK",
                "departureDateTimeRange": {
                    "date": "2024-12-17"
                }
            }
        ],
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
            "ENDDATE_ITN_TZAWARE_EST":  "2025-11-27",
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "Asia/Kolkata",
            "OP": "range"
        },
        "facets": {
            "AIRLINES_NAME_IATA.keyword": [
                "SY",
                "B6",
                "AS",
                "DL",
                "KS",
                "AA",
                "2O",
                "YR",
                "UA"
            ],
        "FLIGHT_AIRLINE_NUM_STOPS": [
                1, 2
            ]
        },
        "org": "09A",
        "dst":"ADQ"
    }
    sojPostPyRq["svcities"] = svcities
    sojPostPyRq["org"] = org.toLocaleUpperCase()
    sojPostPyRq["dst"] = dst.toLocaleUpperCase()
    sojPostPyRq["dates"]["STARTDATE_ITN_TZAWARE_EST"] = STARTDATE_ITN_TZAWARE_EST
    sojPostPyRq["dates"]["ENDDATE_ITN_TZAWARE_EST"] = ENDDATE_ITN_TZAWARE_EST
    sojPostPyRq["dates"]["DT_FORMAT"] = "%Y-%m-%d"
    sojPostPyRq["dates"]["time_zone"] = "Asia/Kolkata"
    sojPostPyRq["dates"]["OP"] = "range"

    sojPostPyRq['esqueryChilds'] = (esqueryChilds ? esqueryChilds : "m0")
    sojPostPyRq['esqueryInfants'] = (esqueryInfants ? esqueryInfants : "i0")
    sojPostPyRq['esqueryAdults'] = (esqueryAdults ? esqueryAdults : "t1")
    sojPostPyRq['esqueryCabin'] = (esqueryCabin ? esqueryCabin : "ECONOMY")
    sojPostPyRq['esqueryTripType'] = "multicity"
    sojPostPyRq['svpageSize'] = 5
    let mo_ss = moment(STARTDATE_ITN_TZAWARE_EST, 'YYYY-MM-DD');
    let mo_es = moment(ENDDATE_ITN_TZAWARE_EST, 'YYYY-MM-DD');
    let svfly_esquery_data = {
        my_orgqueryText: org.toLocaleUpperCase(),
        my_dstqueryText: dst.toLocaleUpperCase(),
        STARTDATE:mo_ss || "2025-11-25",
        ENDDATE: mo_es || "2025-11-27",
        DT_FORMAT: "%Y-%m-%d",
        time_zone: "Asia/Kolkata",
        esqueryChilds:(esqueryChilds ? esqueryChilds : "m0"),
        esqueryInfants:(esqueryInfants ? esqueryInfants : "i0"),
        esqueryAdults:(esqueryAdults ? esqueryAdults : "t1"),
        esqueryCabin:(esqueryCabin ? esqueryCabin : "ECONOMY"),
        esqueryTripType:'multicity',
        svpageSize:5




    }
    
    this.props.flyAndImagesSV(sojPostPyRq, svfly_esquery_data)

      //return this.props.flySaveMcitytReviewSuccess(svmcityOb)
    }
    

    flyAndImagesSVUsingQuery(filter){
        let isFormValid = true
        /*svjul31 test strat const to let */
        const {esqueryMob, esqueryDestMob,startDate, endDate, hotels, 
        esqueryAdults, esqueryCabin,esqueryChilds,esqueryInfants,esqueryTripType} = filter
        let {esqueryText,esqueryDestText} = filter
        /*
        console.log("Validate **sep6**")
        console.log(esqueryText)
        console.log(esqueryDestText)
        console.log(startDate)
        console.log(endDate)
        */
        let myTripType = esqueryTripType ? esqueryTripType : "roundtrip"
        if(myTripType == 'roundtrip'){
            console.log('roundtrip')
            if(startDate && (startDate._d)){

                // isFormValid = true
                 console.log('isFormValid**MOMENSEP7***')
             }else{
                
                 isFormValid = false
               //  console.log('isFormValid**SEP7 DATE***', isFormValid)
             }
     
             if(endDate && (endDate._d)){
     
                 // isFormValid = true
                  console.log('isFormValid**MOMENSEP7***')
              }else{
                 
                  isFormValid = false
                 // console.log('isFormValid**SEP7 DATE***', isFormValid)
              }

        }else if(myTripType == 'onewaytrip' ){
            console.log('onewaytrip')
            if(startDate && (startDate._d)){

                // isFormValid = true
                 console.log('isFormValid**MOMENSEP7***')
             }else{
                
                 isFormValid = false
                // console.log('isFormValid**SEP7 DATE***', isFormValid)
             }

        }else{
            console.log('mc')
        }
       
        if(esqueryText && (esqueryText.length == 3)){
           // isFormValid = true
        }else{
            /*svjul31 hw test start */
           // isFormValid = false
           esqueryText = 'MSP'
           /*svjul31 hw test end */
        }

        if(esqueryDestText && (esqueryDestText.length == 3)){
           // isFormValid = true
        }else{
              /*svjul31 hw test start */
           //  isFormValid = false
           esqueryDestText = 'PMI'
           /*svjul31 hw test end */

           
        }
        
        //onewaytrip
        //roundtrip
        /*
        console.log('esqueryTripType**', esqueryTripType)
        console.log('isFormValid**', isFormValid)
        */
        if(isFormValid === false){
            infoError()
            return
        }
       
       
        
        const {values} = hotels
        //call action
        let start_date_s   = moment(startDate).toISOString() 
        console.log("**formatISO***", start_date_s)


        let moEndDate = moment(endDate)
        let moStartDate = moment(startDate)
        let mo_es = moEndDate.format('YYYY-MM-DD') 
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        let end_date_s   = moment(endDate).toISOString() 
        console.log("**formatISO***", end_date_s)
        let sojourn_location_s = ''
        let qLocation = 'Terrace'
        if(values && values.value){
            sojourn_location_s = values.value
            if(sojourn_location_s == 'benServer'){
                qLocation = 'Brazil'

            }else if(sojourn_location_s == 'jenServer'){
                qLocation = 'usa'
            }else if(sojourn_location_s == 'kenServer'){
                qLocation = 'WA'
            }
        }
        
        let sojPostRq = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": sojourn_location_s,
                  "operator": "and"
                },
                "from_date": {
                    "query": start_date_s,
                    "operator": "and"
                  },
                  "to_date": {
                    "query": end_date_s,
                    "operator": "and"
                  }

              }
            }
          }
          console.log('sv*** calling action with postDatae')
          console.log(sojPostRq)
          console.log('sv*** calling action with postDatae done' )
         
          //esqueryText
          let esRealPostFIlterSearchGoodSVButNodata = {
              "query": {
                  "multi_match": {
                    "fields": [
                        "ORIGIN_AIRPORT_IATA",
                        "ORIGIN_AIRPORT_CITY",
                        "ORIGIN_AIRPORT_COUNTRY",
                        "AIRLINES_NAME",
                        
                         "FLIGHT_SPACE_KEY"
                       
                    ],
        
                      "query": qLocation,
                      "operator": "or",
                      "fuzziness": "AUTO"
                  }
              },
              "post_filter": {
                  "range" : {
                      "STARTDATE": {
                          "gte" : (mo_ss ? mo_ss: "2023-10-24" ),
                          "lt" : (mo_es ? mo_es: "2023-11-27" ), 
                          "time_zone": "+01:00"
                      }
                  }
                }
          }
          let esRealPostFIlterSearch = {
            "query": {
                "multi_match": {
                    "fields": [
                        "ORIGIN_AIRPORT_IATA",
                "ORIGIN_AIRPORT_CITY",
                "ORIGIN_AIRPORT_COUNTRY",
                "AIRLINES_NAME",
                 
                 "FLIGHT_SPACE_KEY"
                       
                    ],
                    "query": qLocation,
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" :  "2023-10-24" ,
                        "lt" :"2023-11-27" , 
                        "time_zone": "+01:00"
                    }
                }
              }
        }
          //woring
          //tmep
          
          //s.toLocaleUpperCase()
          if(esqueryText && esqueryText.length > 2){
            esRealPostFIlterSearch["query"]["multi_match"]["query"] = esqueryText.toLocaleUpperCase()
          }else{
            esRealPostFIlterSearch["query"]["multi_match"]["query"] = 'JFK'
          }
          
          //this.props.flyAndImagesSV(esRealPostFIlterSearch)
          let sojPostPyRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": mo_ss || "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": mo_es || "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
        if(esqueryText && esqueryText.length > 2){
            sojPostPyRq['org'] = esqueryText.toLocaleUpperCase()
          }else{
            sojPostPyRq['org'] = 'JFK'
          }

        sojPostPyRq['org'] = esqueryText.toLocaleUpperCase()
        sojPostPyRq['dst'] = esqueryDestText.toLocaleUpperCase()

        sojPostPyRq['esqueryChilds'] = (esqueryChilds ? esqueryChilds : "m0")
        sojPostPyRq['esqueryInfants'] = (esqueryInfants ? esqueryInfants : "i0")
        sojPostPyRq['esqueryAdults'] = (esqueryAdults ? esqueryAdults : "t1")
        sojPostPyRq['esqueryCabin'] = (esqueryCabin ? esqueryCabin : "ECONOMY")
        sojPostPyRq['esqueryTripType'] = (esqueryTripType ? esqueryTripType : "roundtrip")
        sojPostPyRq['svpageSize'] = 5
        
          let airlines = [
            {
                "name" : "Allegiant Air",
                "IATA" : "G4"
            },
            {
                "name" : "Air Italy",
                "IATA" : "I9"
            },
            {
                "name" : "America West Airlines",
                "IATA" : "HP"
            },
            {
                "name" : "Alaska Airlines",
                "IATA" : "AS"
            },
            {
                "name" : "Atlantic Southeast Airlines",
                "IATA" : "EV"
            },
            {
                "name" : "American Eagle Airlines",
                "IATA" : "MQ"
            },
            {
                "name" : "Delta Air Lines",
                "IATA" : "DL"
            },
            {
                "name" : "Frontier Airlines",
                "IATA" : "F9"
            },
            {
                "name" : "Hawaiian Pacific Airlines",
                "IATA" : "HP"
            },
            {
                "name" : "Indigo",
                "IATA" : "I9"
            },
            {
                "name" : "Jet Airways",
                "IATA" : "QJ"
            },
            {
                "name" : "JetBlue Airways",
                "IATA" : "B6"
            },
            {
                "name" : "Midway Airlines",
                "IATA" : "JI"
            },
            {
                "name" : "Northwest Airlines",
                "IATA" : "NW"
            },
            {
                "name" : "Pearl Airways",
                "IATA" : "HP"
            },
            {
                "name" : "Phoenix Airways",
                "IATA" : "HP"
            },
            {
                "name" : "Sun Country Airlines",
                "IATA" : "SY"
            },
            {
                "name" : "Southwest Airlines",
                "IATA" : "WN"
            },
            {
                "name" : "Spirit Airlines",
                "IATA" : "NK"
            },
            {
                "name" : "Trans World Airlines",
                "IATA" : "TW"
            },
            {
                "name" : "United Airlines",
                "IATA" : "UA"
            },
            {
                "name" : "US Airways",
                "IATA" : "US"
            },
            {
                "name" : "Virgin America",
                "IATA" : "VX"
            },
            {
                "name" : "Caucasus Airlines",
                "IATA" : "NS"
            },
            {
                "name" : "Tway Airlines",
                "IATA" : "TW"
            }
        ]
        let am = {}
        airlines.forEach((o)=>{
            am[o.IATA] = o
        })
        
          let svfly_esquery_data = {
            airlines:airlines
            
            
            ,
            amap:am,
            esqueryDestMob:esqueryDestMob,
            esqueryMob:esqueryMob,
            my_orgqueryText: esqueryText.toLocaleUpperCase(),
            my_dstqueryText: esqueryDestText.toLocaleUpperCase(),
            STARTDATE:mo_ss || "2025-11-25",
            ENDDATE: mo_es || "2025-11-27",
            DT_FORMAT: "%Y-%m-%d",
            time_zone: "Asia/Kolkata",
            esqueryChilds:(esqueryChilds ? esqueryChilds : "m0"),
            esqueryInfants:(esqueryInfants ? esqueryInfants : "i0"),
            esqueryAdults:(esqueryAdults ? esqueryAdults : "t1"),
            esqueryCabin:(esqueryCabin ? esqueryCabin : "ECONOMY"),
            esqueryTripType:(esqueryTripType ? esqueryTripType : "roundtrip"),
            svpageSize:5



    
        }
        this.props.flyAndImagesSV(sojPostPyRq, svfly_esquery_data)
        
         
         

    }
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        //this.loadDDValuesFromServer()
        //console.log(this.props.params)
    }
    componentDidMount(){
        // const f = this.availProcess(this.props.hotelDest,this.props.startDate, this.props.endDate)
        const {hotels,hotelsSelected, ddData, startDate, endDate , dataSourceSV}= this.props.locationData
        let f = {
             all: [], // Contains the full data
             hotels: {
                 options:[
                     { value: 'jen', label: 'jen2Server' },
                     { value: 'ken', label: 'ken2Server' },
                     { value: 'ben', label: 'ben2Server' }
                 ],
                 values: { value: 'ken', label: 'ken2Server' }
             }
         };
         f['hotels']['options'] = hotels
         f['hotels']['values'] = hotelsSelected
         let items = []
         
         let  momIsoStartDate = moment(startDate);
         let  momIsoEndDate = moment(endDate);
 ////var dateComponent = date.utc().format('YYYY-MM-DD');
 //var timeComponent = date.utc().format('HH:mm:ss');
         f['startDate'] = momIsoStartDate
         f['endDate'] = momIsoEndDate
         f['dataSourceSV'] = dataSourceSV
         this.setState({filters:f} )
        // this.setState({filters:f})
 
     }
     
     saveFindState(){
        let f = this.state.filters
        const {endDate,startDate,
            esqueryText, esqueryDestText,
            esqueryChilds, esqueryInfants,esqueryAdults, 
            esqueryCabin,esqueryTripType,escountryDst, escountryOrg } = f

        let moEndDate = moment(endDate)
        let moStartDate = moment(startDate)
        let mo_es = moEndDate.format('YYYY-MM-DD') 
        let mo_ss = moStartDate.format('YYYY-MM-DD') 

        let org_init = 'jfk'
        if(esqueryText){
            //will happen when we are arounfreip for onwaey it will be nul
            org_init = esqueryText
        }

        let dest_init = 'aus'
        if(esqueryDestText){
            //will happen when we are arounfreip for onwaey it will be nul
            dest_init = esqueryDestText
        }
        let svfly_esquery_data = {
            my_orgqueryText: org_init.toLocaleUpperCase(),
           // my_dstqueryText: esqueryDestText.toLocaleUpperCase(),
            //my_orgqueryText: esqueryText.toLocaleUpperCase(),
            my_dstqueryText: dest_init.toLocaleUpperCase(),
            STARTDATE:mo_ss || "2025-11-25",
            ENDDATE: mo_es || "2025-11-27",
            DT_FORMAT: "%Y-%m-%d",
            time_zone: "Asia/Kolkata",
            escountryOrg:(escountryOrg ? escountryOrg : "US"),
            escountryDst:(escountryDst ? escountryDst : "US"),
            esqueryChilds:(esqueryChilds ? esqueryChilds : "m0"),
            esqueryInfants:(esqueryInfants ? esqueryInfants : "i0"),
            esqueryAdults:(esqueryAdults ? esqueryAdults : "t1"),
            esqueryCabin:(esqueryCabin ? esqueryCabin : "ECONOMY"),
            esqueryTripType:(esqueryTripType ? esqueryTripType : "roundtrip"),
            svpageSize:5
        }
        
         let newfindData = { 'svfly_esquery_data' : svfly_esquery_data}
        this.props.saveFindEsQueryDataSuccess(newfindData)

     }

     handleChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryTripType'] = !qText ? 'roundtrip' :  qText
        this.setState({filters:f} )
        this.saveFindState()
        /*
        const {endDate,startDate,
            esqueryText, esqueryDestText,
            esqueryChilds, esqueryInfants,esqueryAdults, 
            esqueryCabin,esqueryTripType } = f

        let moEndDate = moment(endDate)
        let moStartDate = moment(startDate)
        let mo_es = moEndDate.format('YYYY-MM-DD') 
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        let dest_init = 'aus'
        if(esqueryDestText){
            //will happen when we are arounfreip for onwaey it will be nul
            dest_init = esqueryDestText
        }
        let svfly_esquery_data = {
            my_orgqueryText: esqueryText.toLocaleUpperCase(),
           // my_dstqueryText: esqueryDestText.toLocaleUpperCase(),
            my_dstqueryText: dest_init.toLocaleUpperCase(),
            STARTDATE:mo_ss || "2025-11-25",
            ENDDATE: mo_es || "2025-11-27",
            DT_FORMAT: "%Y-%m-%d",
            time_zone: "Asia/Kolkata",
            esqueryChilds:(esqueryChilds ? esqueryChilds : "m0"),
            esqueryInfants:(esqueryInfants ? esqueryInfants : "i0"),
            esqueryAdults:(esqueryAdults ? esqueryAdults : "t1"),
            esqueryCabin:(esqueryCabin ? esqueryCabin : "ECONOMY"),
            esqueryTripType:(esqueryTripType ? esqueryTripType : "roundtrip"),
            svpageSize:5
        }
        
         let newfindData = { 'svfly_esquery_data' : svfly_esquery_data}
        this.props.saveFindEsQueryDataSuccess(newfindData)

        */
    }

    constructor(props) {
        super(props)
        let me = this
        this.disabledTimeCb = this.disabledTimeCb.bind(me)
        this.momDefaultDateR = this.momDefaultDateR.bind(me)
        this.momDefaultDate = this.momDefaultDate.bind(me)
        this.svsubmitparentmci = this.svsubmitparentmci.bind(this)
        this.onSearchOrgtxtFancy = this.onSearchOrgtxtFancy.bind(this)
        this.onSearchDesttxtFancy = this.onSearchDesttxtFancy.bind(this)
        this.onSearchOrgtxt = this.onSearchOrgtxt.bind(this)
        this.onSearchDesttxt = this.onSearchDesttxt.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleTravellerChange = this.handleTravellerChange.bind(this)
        //handleOrgCountryChange
        this.handleOrgCountryChange = this.handleOrgCountryChange.bind(this)
        this.handleDstCountryChange = this.handleDstCountryChange.bind(this)

        this.handleChildChange = this.handleChildChange.bind(this)
        this.handleCabinChange = this.handleCabinChange.bind(this)
        this.flyAndImagesSVUsingQuery = this.flyAndImagesSVUsingQuery.bind(this)
        this.onTripChange_cosmos = this.onTripChange_cosmos.bind(this)
        this.getTripHtmlPicker = this.getTripHtmlPicker.bind(this)
        this.getCityTravelTypeView = this.getCityTravelTypeView.bind(this)
        this.onTripChange_Oneway_cosmos = this.onTripChange_Oneway_cosmos.bind(this)
        this.onTripChange = this.onTripChange.bind(this)
        this.saveFindState = this.saveFindState.bind(this)
        this.state = { 
            value: '', 
            inputValueds:'',
            //inputValue:'react',
            selectedOptionds: '',
            inputValue:'react',
           
            //inputValue:'react',
            selectedOption: { label: "react", value: "3" },
            dataSource:[
                { label: "hello", value: "1" },
                { label: "codesandbox", value: "2" },
                { label: "react", value: "3" },
                { label: "nodejs", value: "4" },
                { label: "java", value: "5" },
                { label: "antd", value: "6" },
                { label: "dependency", value: "7" },
                { label: "less", value: "8" }
              ],
            /*
            svstate : {
                startDate: new Date(),
                endDate: new Date(),
           
            key: 'selection'
            },  
            */
            ids: ['APP_OPERATIONAL_STATUS', 'DV_U_SERVICE_ASG', 'DV_U_SERVICE_NAME', 'DV_U_SERVICE_OFFERING', 'APPLICATION_NAME'],
            labels: ['Status', 'Service ASG', 'Service Name', 'Service Offering', 'Application'],
            filters: {
                
                all: [], // Contains the full data
                //"startDate": "2024-07-22T23:42:55.795+00:00" ,
               // "endDate": "2024-07-22T25:42:55.795+00:00" ,
               startDate : new Date(),
               endDate : new Date(),
               escountryOrg:"US",
               escountryDst:"US",

               esqueryAdults:"t1",
               esqueryChilds:"m1",
               esqueryInfants:"i0",
               esqueryCabin:"ECONOMY",
               esqueryTripType:"roundtrip",
               
               esqueryDestMob :{
                "type": "location",
                "subType": "AIRPORT",
                "name": "JOHN F KENNEDY INTL",
                "detailedName": "NEW YORK/NY/US:JOHN F KENNEDY",
                "id": "AJFK",
                
                "timeZoneOffset": "-04:00",
                "iataCode": "JFK",
                "geoCode": {
                  "latitude": 40.63973,
                  "longitude": -73.77861
                },
                "address": {
                  "cityName": "NEW YORK",
                  "cityCode": "NYC",
                  "countryName": "UNITED STATES OF AMERICA",
                  "countryCode": "US",
                  "stateCode": "NY",
                  "regionCode": "NAMER"
                },
                "analytics": {
                  "travelers": {
                    "score": 35
                  }
                }
              },
               esqueryMob :{
                   iataCode: "ORD",
                   address:  { cityName: "CHICAGO", cityCode: "CHI", countryName: "UNITED STATES OF AMERICA" },
                   detailedName: "CHICAGO/IL/US:O HARE INTERNATI",
                   geoCode:  { latitude: 41.97862, longitude: -87.90472 },

                },
               esqueryText: '',
               esqueryDestText: '',
               dataSourceSV : ['Burns Bay Road', 'Downing Street', 'Wall Street'],
            
              
                key: 'selection',
                "hotelsSelected":{"value": "kenServer", "label": "kenServer"},
                hotels: {
                    
                    options:[
                        { value: 'jen', label: 'jen1Server' },
                        { value: 'ken', label: 'ken1Server' },
                        { value: 'ben', label: 'ben1Server' }
                    ],
                    values: { value: 'ken', label: 'ken1Server' }
            },
                HOTEL_DEST: {
                    id: "HOTEL_DEST_STATUS", 
                    defaultOptions: [], 
                    options: [],
                    label: "Hptel Location",
                    values: [],
                    showing: []

                },
                HOTEL_DATE_RANGE: {
                   
                        startDate: new Date(),
                        endDate: new Date(),
                   
                    key: 'selection'
                    
                },
                APP_OPERATIONAL_STATUS:{
                    id: "APP_OPERATIONAL_STATUS", 
                    defaultOptions: [], 
                    options: [],
                    label: "Status",
                    values: [],
                    showing: []
                },
                
                APPLICATION_NAME: {
                    id: "APPLICATION_NAME",
                    defaultOptions: [],
                    options: [],
                    label: "Applications",
                    values: [],
                    showing: []
                }
              
            }
        }
    }
   

    handleTravellerChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryAdults'] = !qText ? 't1' :  qText
        this.setState({filters:f} )
        this.saveFindState()

    }
    handleCabinChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryCabin'] = !qText ? ["ECONOMY"] :  qText
        this.setState({filters:f} )
        this.saveFindState()


    }
    
    handleOrgCountryChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['escountryOrg'] = !qText ? 'US' :  qText
        this.setState({filters:f} )
        this.saveFindState()


    }
    handleDstCountryChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['escountryDst'] = !qText ? 'US' :  qText
        this.setState({filters:f} )
        this.saveFindState()


    }

    handleChildChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryChilds'] = !qText ? 'm1' :  qText
        this.setState({filters:f} )
        this.saveFindState()


    }
    handleInfantChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryInfants'] = !qText ? 'i0' :  qText
        this.setState({filters:f} )
        this.saveFindState()


    }
   
    onTripChange_Oneway_cosmos(dateMoment, sdate ){
        console.log(sdate)
        let fmd = dateMoment
        let fmo = fmd
       
        let moStartDate = moment(fmo)
        console.log(fmd)
      
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
      
        let start_date_s   = moStartDate.toISOString() 
        console.log("from**formatISO***", start_date_s)
  
        let f = this.state.filters
        let today_dt = new Date()
        f['startDate'] = !fmo ? today_dt :  fmo
       
        this.setState({filters:f} )
        this.saveFindState()
        

    }

    onTripChange(dateMoment, sdate, tpdateMoment, tosdate ){
        console.log(sdate)
        let fmd = dateMoment
        let fmo = fmd[0]
        let tmo = fmd[1]
        let moEndDate = moment(tmo)
        let moStartDate = moment(fmo)
        console.log(fmd)
        let mo_es = moEndDate.format('YYYY-MM-DD') 
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        let end_date_s   = moEndDate.toISOString() 
        let start_date_s   = moStartDate.toISOString() 
        console.log("from**formatISO***", start_date_s)
        console.log("To**formatISO***", end_date_s)
        this.saveFindState()
        

    }
    disabledDate = (curDate) => {
        console.log('disabledDate***SEP4*** called')
        let isValid = false, isMinValid = false, isMaxValid = false

        let daysMax = 0, days = 0
        let today = moment(), todayMax = moment()
        let minMom = null, maxMom = null
        // const {COSMOS_DEF_SEARCH_ADV_DAYS} 
         let  advBy = parseInt(COSMOS_DEF_SEARCH_ADV_DAYS) ? parseInt(COSMOS_DEF_SEARCH_ADV_DAYS) : 13
         let  advEndBy = parseInt(COSMOS_DEF_MAX_ALL_ADV_DAYS) ? parseInt(COSMOS_DEF_MAX_ALL_ADV_DAYS) : 364
         
        
        if(today){
            minMom = today.add(advBy, 'days')
        }
          days = minMom.diff(curDate)
         if( days > 0){
            isMinValid = true
           // isValid = true
         }
         
         
        
         if(todayMax){
            maxMom = today.add( advEndBy, 'days')
        }

         daysMax = maxMom.diff(curDate)
         console.log(daysMax)
         if( daysMax < 0){
            isMaxValid = true
           // isValid = true
        }
        
        
        if( (isMaxValid === true) || (isMinValid === true)){
            isValid = true
        }else{
            isValid = false
        }
        
         //cannot be less than a 


        return isValid
      }
      disabledDateR = (curDate1, curDate2) => {
        let isValidR = false
        let isValid1 = false
        let isValid2 = false
        console.log('disabledDateR rangepicker***SEP4*** called')
       
        isValid1 = this.disabledDate(curDate1)

        if( (isValid1 === true)){
            isValidR = true
        }else{
            isValidR = false
        }
        
        return isValidR



      }
     disabledTimeSVgood = (date) => {
        if (date.isSame('2024-01-01', 'day')) {
          return {
            disabledHours: () => Array.from({ length: 24 }, (_, i) => i).filter((hour) => hour < 9),
          };
        }
      
        if (date.isSame('2024-01-02', 'day')) {
          return {
            disabledHours: () => Array.from({ length: 24 }, (_, i) => i).filter((hour) => hour > 17),
          };
        }
      
        // Only need to consider the start and end time
        // the range itself has been disabled by `disabledDate`
        return {};
      };
    disabledTimeCb(dates, partial){
        console.log('disabledTimeCb called')
        let today = moment(), todatD = moment()
        console.log(partial)
       
        let oMom = null, dMom = null
        let dar = [today, today]
        console.log( partial)
          
            oMom = today.add(24, 'days')
             dMom  = todatD.add(30, 'days')
             dar = []
             dar.push(oMom)
             dar.push(dMom)
             dates = dar

    }
    momDefaultDateR(){
        let oMom = null, dMom = null
        let today = moment(), todatD = moment()
        let dar = [today, today]
        // const {COSMOS_DEF_SEARCH_ADV_DAYS} 
         let  advBy = parseInt(COSMOS_DEF_ROUND_ADV_DAYS_O) ? parseInt(COSMOS_DEF_ROUND_ADV_DAYS_O) : 14
         let  advRBy = parseInt(COSMOS_DEF_ROUND_ADV_DAYS_D) ? parseInt(COSMOS_DEF_ROUND_ADV_DAYS_D) : 20
         

         if(today){
             oMom = today.add(advBy, 'days')
             dMom  = todatD.add(advRBy, 'days')
             dar = []
             dar.push(oMom)
             dar.push(dMom)
         }
        
 
 
         return dar

    }
    momDefaultDate(){
        /*
            export const COSMOS_DEF_SEARCH_ADV_DAYS= "14"
export const COSMOS_DEF_ROUND_ADV_DAYS_O= "14"
export const COSMOS_DEF_ROUND_ADV_DAYS_D= "21"
export const COSMOS_DEF_MCITY_ADV_DAYS_1= "14"
export const COSMOS_DEF_MCITY_ADV_DAYS_2= "29"
export const COSMOS_DEF_MCITY_ADV_DAYS_3= "34"
        */
        let today = moment()
       // const {COSMOS_DEF_SEARCH_ADV_DAYS} 
        let  advBy = parseInt(COSMOS_DEF_SEARCH_ADV_DAYS) ? parseInt(COSMOS_DEF_SEARCH_ADV_DAYS) : 13
        let defMom = moment('2026-09-23', 'YYYY-MM-DD')
        if(today){
            defMom = today.add(advBy, 'days')
        }
       


        return defMom
    }
    onTripChange_cosmos(dateMoment, sdate, tpdateMoment, tosdate ){
        console.log(sdate)
        let fmd = dateMoment
        let fmo = fmd[0]
        let tmo = fmd[1]
        let moEndDate = moment(tmo)
        let moStartDate = moment(fmo)
        console.log(fmd)
        let mo_es = moEndDate.format('YYYY-MM-DD') 
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        let end_date_s   = moEndDate.toISOString() 
        let start_date_s   = moStartDate.toISOString() 
        console.log("from**formatISO***", start_date_s)
        console.log("To**formatISO***", end_date_s)
        let f = this.state.filters
        let today_dt = new Date()
        f['startDate'] = !fmo ? today_dt :  fmo
        f['endDate'] = !tmo ? today_dt :  tmo
        this.setState({filters:f} )
        this.saveFindState()

    }
    //svapr7

    onSearchOrgtxtFancyBak = qText => {
        
        console.log('SV*********** APR7 GOT TA selectom options.name 0')
        
        console.log('SV*********** APR7 GOT TA selectom options.name', qText)
        
        let f = this.state.filters
       
     
        f['esqueryText'] = !qText ? [] :  qText
        this.setState({filters:f} )
        this.saveFindState()
        
      };
    onSearchOrgtxtFancy = mob => {
        
        console.log('KN*********** July17 GOT SVKAirport  selectom options.name 0')
        
        console.log(mob)
        let f = this.state.filters
       
        f['esqueryMob'] = !mob  ? {} :mob
        let qText = mob.IATA
       
        f['esqueryText'] = !qText ? [] :  qText
        console.log('SV*********** APR7 GOT TA selectom options.name', qText)
        
        this.setState({filters:f} )
        this.saveFindState()
        
      };
  
    onSearchOrgtxt = qText => {
        
        let f = this.state.filters
       
     
        f['esqueryText'] = !qText ? [] :  qText
        this.setState({filters:f} )
        this.saveFindState()
        
      };
      onSearchDesttxtFancy = mob => {
    
        let f = this.state.filters
        
        f['esqueryDestMob'] = !mob  ? {} :mob
        let qText = mob.IATA
       
        console.log('SV*********** APR7 GOT TA esqueryDestMob selectom options.name', qText)
        
       
     
        f['esqueryDestText'] = !qText ? [] :  qText
        this.setState({filters:f} )
        this.saveFindState()
        
      };
      onSearchDesttxt = qText => {
    
        let f = this.state.filters
       
     
        f['esqueryDestText'] = !qText ? [] :  qText
        this.setState({filters:f} )
        this.saveFindState()
        
      };
     

    getTripHtmlPicker(qt){
        if(qt == 'onewaytrip'){
           

            return (
                
                <div>
                                <br />
                                <Card title="Travel Departure - Return" bordered={false} style={{ width: 300 }}>
                                    <DatePicker disabledDate={this.disabledDate} defaultValue={this.momDefaultDate()} onChange={this.onTripChange_Oneway_cosmos} />
                                </Card>
                </div>

            )
            
        }else if(qt == 'roundtrip'){ 
            return (
                
                <div>
                                <br />
                                <Card title="Travel Departure - Return" bordered={false} style={{ width: 300 }}>
                                    <RangePicker disabledDate={this.disabledDateR} defaultPickerValue={this.momDefaultDateR()} defaultValue={this.momDefaultDateR()} onChange={this.onTripChange_cosmos} />
                                </Card>
                </div>

            )
            
        }else{

            return (
                
                <div>
                                <br />
                                <Card title="Travel Departure - Return" bordered={false} style={{ width: 300 }}>
                                    <RangePicker onChange={this.onTripChange_cosmos} />
                                </Card>
                </div>

            )
        }
        
    }
    render(){
        
      
       
       
        //sva21 end
        let {svfly_esquery_data, my_data_geo} = this.props
        let countryTypes = null
       

    
        if(my_data_geo){

       
            countryTypes = my_data_geo.countryTypes
        }
       
        if(!countryTypes){
            countryTypes = [
                {
                    "name": "United STates America",
                    "a2": "US",
                    "a3": "USA",
                    "value": "USA",
                    "isonum": "840"
                },
                {
                    "name": "Canada",
                    "isdcode": "01",
                    "a2": "CA",
                    "a3": "CAN",
                    "value": "CAN",
                    "isonum": "124"
                }
            ]
        }

        let qt = svfly_esquery_data['esqueryTripType'] ? svfly_esquery_data['esqueryTripType'] :'roundtrip'
       
         //svnov17 start
         const {svsubmitparentmci} = this
         let detmci = {
            "id": "addLeft_step",
            "testlastName": "svlondonKW",
            "gene":"svgene",
           
            "members": [
                {
                    "tid": 1,
                    "my_orgqueryText": "JFK",
                    "my_dstqueryText": "LAX",
                    "STARTDATE":"2024-12-03",
                    "DT_FORMAT": "%Y-%m-%d",
                    "time_zone": "Asia/Kolkata"
                   
                },
                {
                    "tid": 2,
                    "my_orgqueryText": "LAX",
                    "my_dstqueryText": "SFO",
                    "STARTDATE":"2024-12-07",
                    "DT_FORMAT": "%Y-%m-%d",
                    "time_zone": "Asia/Kolkata"
                   
                },
                {
                    "tid": 3,
                    "my_orgqueryText": "SFO",
                    "my_dstqueryText": "JFK",
                    "STARTDATE":"2024-12-17",
                    "DT_FORMAT": "%Y-%m-%d",
                    "time_zone": "Asia/Kolkata"
                   
                }
            ],
               "gender": "MALE"
        }
        return (
            <div>
            <div className="searchBar">
        <div className="container-fluid">
            {/* 
            <div className="row">
                    <div>
                            <Chat />
                    </div>
            </div>
             */}
            <div className="row">
            <div className="c-container-profilebar">
                <div className="c-box-profilebar">
                    <span className="c-span">
                        <Select defaultValue="roundtrip" style={{ width: 120 }} onChange={this.handleChange}>
                        <Option value="roundtrip">Round Trip</Option>
                        <Option value="onewaytrip">One Way</Option>
                        <Option value="multicity" >
                            Multi City
                        </Option>
                        {/* 
                        <Option value="Yiminghe" disabled>yiminghe</Option>
                        */}
                        </Select>
                    </span>
                </div>
                <div className="c-box-profilebar">
                            <span className="c-span">
                            <Select defaultValue="t1" style={{ width: 120 }} onChange={this.handleTravellerChange}>
                            <Option value="t1">1 Adult</Option>
                            <Option value="t2">2 Adult</Option>
                            <Option value="t3">3 Adult</Option>
                            <Option value="t4">4 Adult</Option>
                            <Option value="t5">5 Adult</Option>
                            <Option value="t6">6 Adult</Option>
                            
                            </Select>
                            </span>
                </div>
                <div className="c-box-profilebar">
                            <span className="c-span">
                            <Select defaultValue="m0" style={{ width: 120 }} onChange={this.handleChildChange}>
                            <Option value="m0">No Child</Option>
                            <Option value="m1">1 Child</Option>
                            <Option value="m2">2 Child</Option>
                            
                            </Select>
                            </span>
                </div>
                <div className="c-box-profilebar">
                            <span className="c-span">
                            <Select defaultValue="ECONOMY" style={{ width: 120 }} onChange={this.handleCabinChange}>
                            <Option value="c0">Show All </Option>
                            <Option value="ECONOMY">Basic Economy</Option>
                
    
                            <Option value="PREMIUM_ECONOMY">Premium Economy</Option>
                            <Option value="BUSINESS">Business</Option>
                            <Option value="FIRST">First</Option>
                            
                            </Select>
                            </span>
                </div>
    </div>
    {this.getCityTravelTypeView(qt, detmci, svsubmitparentmci,countryTypes,svfly_esquery_data)}
    {/*  
                <div className="c-container-sbar">
                        <div className="c-box-flybar">
                            <span className="c-span">
                            <div>
        
                                <br />
                                <Card title="From"  bordered={false} style={{ width: 300 }}>
                                   
                                    <Search
                                        placeholder="From"
                                        onSearch={this.onSearchOrgtxt}
                                        style={{ width: 200 }}
                                        />
                                    </Card>
                            </div>
                            
                            </span>
                        </div>
                        <div className="c-box-flybar">
                            <span className="c-span">
                            <div>
                                <br />
                                <Card title="To" bordered={false} style={{ width: 300 }}>
                                    <Search
                                        placeholder="To"
                                        onSearch={this.onSearchDesttxt}
                                        style={{ width: 200 }}
                                        />
                                </Card>
                            </div>
                            
                            </span>
                        </div>
                        <div className="c-box-flybar">
                            <span className="c-span">
                            {this.getTripHtmlPicker(qt)}
                            
                            </span>
                        </div>

                       
                        <div className="c-box-flybar">
                                <span className="c-span">
                                <div>
                                <br />
                                <Card bordered={false}  style={{ width: 300 }}>
                            
                                    <button type="submit" className="btn btn-success" onClick={()=>this.flyAndImagesSVUsingQuery(this.state.filters)}>
                                        SearchFlightsSV
                                    </button> 
                                </Card>
                                </div>
                                </span>
                        </div>
                </div>
    */}
            </div>
        </div>
            </div></div>

        )
    }


getCityTravelTypeView(qt, detmci, svsubmitparentmci, countryTypes,svfly_esquery_data){
    if(qt == 'multicity'){
        return(
            
                <FlyMciFormBusCom countryTypes={countryTypes} det={detmci}  svsubmitparentmci={svsubmitparentmci} onSubmit={svsubmitparentmci}></FlyMciFormBusCom>

                
              
        )


    }else{

   

    return (
        <div className="c-container-sbar">
                        <div className="c-box-flybar-travel">
                            <span className="c-span">
                            <div>
        
                                <br />
                                <Card title="From"  bordered={false} style={{ width: 265 }}>
                                   {/* 
                                     <Search
                                        placeholder="From"
                                        onSearch={this.onSearchOrgtxt}
                                        style={{ width: 200 }}
                                        />
                                   
                                    
                                     <div className="form-group">
                                                <label htmlFor="country" > Country</label>
                                                <Field  component="select" id="country"   name="country"  className="form-control" >
                                                
                                                    <option value="">Select Country A3</option>
                                                    {
                                        
                                                
                                        countryTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                                    </div>
                                     */}
                                     {/*svaug1   <SVRAiport svfly_esquery_data={svfly_esquery_data} onSearchOrgtxtFancy={this.onSearchOrgtxtFancy}/>  */}
                                      <SVKAiport svfly_esquery_data={svfly_esquery_data} onSearchOrgtxtFancy={this.onSearchOrgtxtFancy}/>
                                       
                                                <Select onChange={this.handleOrgCountryChange} defaultValue="US" style={{ width: 150, marginTop:"6px" }} >
                                                <Option value="roundtrip">Round Trip</Option>
                                                <Option value="onewaytrip">One Way</Option>
                                                {
                                                        
                                                                
                                                        countryTypes.map(  (o, idx)=>( 
                                                            <Option value={o.a2} key={o.name}>{o.name}</Option>
                                                            )
                                                                    
                                                                    
                                                                    
                                                                
                                                                )}
                                                </Select>
                                           
                                    </Card>
                            </div>
                            
                            </span>
                        </div>
                        <div className="c-box-flybar-travel">
                            <span className="c-span">
                            <div>
                                <br />
                                <Card title="To" bordered={false} style={{ width: 265 }}>
                                    {/* 
                                   
                                    <Search
                                        placeholder="To"
                                        onSearch={this.onSearchDesttxt}
                                        style={{ width: 200 }}
                                        />
                                         */}
                                  <SVKAirportDest svfly_esquery_data={svfly_esquery_data} onSearchDesttxtFancy={this.onSearchDesttxtFancy}/>
                                 
                                <Select onChange={this.handleDstCountryChange} defaultValue="US" style={{ width: 170, marginTop:"6px" }} >
                                                <Option value="roundtrip">Round Trip</Option>
                                                <Option value="onewaytrip">One Way</Option>
                                                {
                                                        
                                                                
                                                        countryTypes.map(  (o, idx)=>( 
                                                            <Option value={o.a2} key={o.name}>{o.name}</Option>
                                                            )
                                                                    
                                                                    
                                                                    
                                                                
                                                                )}
                                </Select>
                                          
                                    
                                    
                                </Card>
                            </div>
                            
                            </span>
                        </div>

                       
                        <div className="c-box-flybar-travel">
                            <span className="c-span">
                            {this.getTripHtmlPicker(qt)}
                            
                            </span>
                        </div>

                       
                        <div className="c-box-flybar-travel">
                                <span className="c-span">
                                <div>
                                <br />
                                <Card bordered={false}  style={{ width: 130 }}>
                            
                                    <button type="submit" className="btn btn-success" onClick={()=>this.flyAndImagesSVUsingQuery(this.state.filters)}>
                                        Search
                                    </button> 
                                </Card>
                                </div>
                                </span>
                        </div>
                </div>
    )
  } 
}


}



export default FlySearchBar